import { YOO_FINDS_H5_CDN_URL } from "@/common/domains";

const baseUrl = `${YOO_FINDS_H5_CDN_URL}/h5/activity/2025/christmas`;

export const CHRISTMAS_SNOWFLAKE_1 = `${baseUrl}/snowflake_1.png`;
export const CHRISTMAS_SNOWFLAKE_2 = `${baseUrl}/snowflake_2.png`;
export const CHRISTMAS_SNOWFLAKE_3 = `${baseUrl}/snowflake_3.png`;
export const CHRISTMAS_THEME = `${baseUrl}/theme.png`;
export const CHRISTMAS_SHARE = `${baseUrl}/share.png`;
export const CHRISTMAS_LINK_LINE = `${baseUrl}/link_line.png`;
export const CHRISTMAS_GINGERBREAD_MAN = `${baseUrl}/gingerbread_man.png`;
export const CHRISTMAS_TREE = `${baseUrl}/christmas-tree.png`;
export const CHRISTMAS_GIFT = `${baseUrl}/gift.png`;
export const CHRISTMAS_BELL = `${baseUrl}/bell.png`;
export const CHRISTMAS_CANDY_STICK = `${baseUrl}/candy-stick.png`;
export const CHRISTMAS_BAUBLE_ILLUSTRATION = `${baseUrl}/bauble-illustration.png`;
export const CHRISTMAS_DECORATIONS_TREE = `${baseUrl}/decorations-tree.png`;
export const CHRISTMAS_HAT = `${baseUrl}/hat.png`;
export const CHRISTMAS_PICK_ICON = `${baseUrl}/pick-tree.png`;
export const CHRISTMAS_YOOFINDS_LOGO = `${baseUrl}/yoofinds-logo.png`;
